import { analytics } from "MVVM/Analytics";

// Every click-style event across the activity feed (main feed cards + the
// sidebar widgets) shares "activity_feed" as its location so they're all
// filterable together; locationIdentifier is what distinguishes
// react/comment/profile/card clicks from each other.
export const trackFeedClick = (
  locationIdentifier: string,
  properties: Record<string, unknown> = {},
) => {
  analytics.track("Button - Click", {
    locationIdentifier,
    location: "activity_feed",
    ...properties,
  });
};
